import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { useState, useCallback, useEffect } from 'react';
import { debounce } from '@elliemae/ds-utilities/utils';

function handleSearch(clearOnSearch, setValue, searchOnEnter, value, onSearch, property, clickTrigger, onSearchButtonClick) {
  if (clickTrigger) {
    onSearchButtonClick();
  }

  if (clearOnSearch) setValue('');
  if (searchOnEnter && !value) return;
  onSearch({
    query: _defineProperty({}, property, value),
    property: property,
    value: value
  });
}

function useSearch() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onKeyUp = params.onKeyUp,
      onSearch = params.onSearch,
      onSearchButtonClick = params.onSearchButtonClick,
      property = params.property,
      clearOnSearch = params.clearOnSearch,
      searchOnEnter = params.searchOnEnter,
      onChange = params.onChange;

  var _useState = useState(params.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var debouncedSearch = useCallback(debounce(handleSearch, 200), []); // update state if prop changes

  useEffect(function () {
    if (value !== params.value) {
      setValue(params.value);
    }
  }, [params.value]);

  var searchWithParams = function searchWithParams() {
    var clickedSearchButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return handleSearch(clearOnSearch, setValue, searchOnEnter, value, onSearch, property, clickedSearchButton, onSearchButtonClick);
  };

  var handleChange = function handleChange(_ref) {
    var target = _ref.target;
    onChange(target.value);
    setValue(target.value);

    if (!searchOnEnter) {
      // Functional update to get latest value state, similar to this.setState callback
      setValue(function (prevValue) {
        debouncedSearch(clearOnSearch, setValue, searchOnEnter, prevValue, onSearch, property);
        return prevValue;
      });
    }
  };

  var handleClear = function handleClear() {
    onChange('');
    setValue('');

    if (!searchOnEnter) {
      // Functional update to get latest value state, similar to this.setState callback
      setValue(function (prevValue) {
        debouncedSearch(clearOnSearch, setValue, searchOnEnter, prevValue, onSearch, property);
        return prevValue;
      });
    }

    debouncedSearch(clearOnSearch, setValue, searchOnEnter, value, onSearch, property);
  };

  var handleKeyUp = function handleKeyUp(e) {
    var key = e.key;

    if (searchOnEnter && key === 'Enter') {
      searchWithParams();
    }

    onKeyUp(e);
  };

  return {
    searchValue: value,
    handleChange: handleChange,
    handleSearch: searchWithParams,
    handleKeyUp: handleKeyUp,
    handleClear: handleClear
  };
}

export { useSearch };
//# sourceMappingURL=useSearch.js.map
